import { JsonAsset, Asset, SpriteFrame, BitmapFont } from 'cc';

export enum AssetName {
    JSON = 'json',
    SPRITE_FRAME = 'spriteFrame',
    FONT = 'font',
}

export const assetNameToAssetTypeMap: Partial<Record<AssetName, typeof Asset>> = {
    [AssetName.JSON]: JsonAsset,
    [AssetName.SPRITE_FRAME]: SpriteFrame,
    [AssetName.FONT]: BitmapFont,
};

/**
 * Base type for loading remote asset
 */
export type PathLoadingConfigType =
    | string
    | {
          path: string;
      };

/**
 * Font type for loading remote font asset
 */
export type FontPathLoadingConfigType = {
    fontPath: string;
    imagePath?: string;
};

export type AssetNameTypeMap = {
    [AssetName.JSON]: string;
    [AssetName.SPRITE_FRAME]: PathLoadingConfigType;
    [AssetName.FONT]: FontPathLoadingConfigType;
};

export enum ImageFormat {
    ASTC = '.astc',
    AVIF = '.avif',
    WEBP = '.webp',
    PNG = '.png',
}

export type RemoteAssetLoadingConfigType = {
    baseURL: string;
    prefix?: string;
    /**
     * add asset name as part of the path, e.g. prefix/spriteFrame/assetPath
     */
    prefixWithAssetName?: boolean;
    /**
     * Supported image formats used to resolve image extension
     * when the asset path does not include one.
     */
    imagesFormats?: ImageFormat[];
    path: Partial<{
        [K in keyof AssetNameTypeMap]: Record<string, AssetNameTypeMap[K]>;
    }>;
};

export default RemoteAssetLoadingConfigType;
